"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingPriceType = exports.ShippingType = exports.QuoteTransitionActivities = exports.QuoteTransitionName = exports.QuoteStatus = exports.OrderableType = exports.CartLockState = void 0;
var api_service_1 = require("./api-service");
var CartService = /** @class */ (function (_super) {
    __extends(CartService, _super);
    function CartService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'cart';
        return _this;
    }
    CartService.prototype.getOrderableEndpoint = function (orderable) {
        return "".concat(orderable.type === OrderableType.QUOTE ? 'quotes' : 'carts', "/").concat(orderable.id);
    };
    CartService.prototype.carts = function (params) {
        return this.getCollectionRequest(this.url('carts'), {
            params: params,
        });
    };
    CartService.prototype.createCart = function (data) {
        return this.postRequest(this.url('carts'), data);
    };
    CartService.prototype.massDeleteCarts = function (data) {
        return this.deleteRequest(this.url('carts'), { data: data });
    };
    CartService.prototype.getCart = function (id) {
        return this.getRequest(this.url('carts', id));
    };
    CartService.prototype.deleteCart = function (id) {
        return this.deleteRequest(this.url('carts', id));
    };
    CartService.prototype.lockCart = function (id, state) {
        return this.patchRequest(this.url('carts', id, 'lock'), { state: state });
    };
    CartService.prototype.unlockCart = function (id) {
        return this.patchRequest(this.url('carts', id, 'unlock'), undefined);
    };
    CartService.prototype.setBillingAddressIdInOrderable = function (orderable, addressId) {
        return this.putRequest(this.url(this.getOrderableEndpoint(orderable), 'addresses'), {
            billing_address_id: addressId,
        });
    };
    CartService.prototype.setShippingAddressIdInOrderable = function (orderable, addressId) {
        return this.putRequest(this.url(this.getOrderableEndpoint(orderable), 'addresses'), {
            shipping_address_id: addressId,
        });
    };
    CartService.prototype.updateAddressesInOrderable = function (orderable, data) {
        return this.putRequest(this.url(this.getOrderableEndpoint(orderable), 'addresses'), data);
    };
    CartService.prototype.checkoutOrderable = function (orderable, data) {
        return this.postRequest(this.url(this.getOrderableEndpoint(orderable), 'checkout'), data);
    };
    CartService.prototype.updateDiscountInOrderable = function (orderable, discount) {
        return this.patchRequest(this.url(this.getOrderableEndpoint(orderable), 'discount'), discount);
    };
    CartService.prototype.updateCustomerInOrderable = function (orderable, customer) {
        var url = this.url(this.getOrderableEndpoint(orderable), 'customer');
        return this.patchRequest(url, customer);
    };
    CartService.prototype.addItemsToOrderable = function (orderable, items) {
        return this.postRequest(this.url(this.getOrderableEndpoint(orderable), 'items'), { items: items });
    };
    CartService.prototype.deleteItemsInOrderable = function (orderable, itemIds) {
        return this.deleteRequest(this.url(this.getOrderableEndpoint(orderable), 'items'), {
            data: { ids: itemIds },
        });
    };
    CartService.prototype.deleteAllItemsInOrderable = function (orderable) {
        return this.deleteRequest(this.url(this.getOrderableEndpoint(orderable), 'items'));
    };
    CartService.prototype.updateItemInOrderable = function (orderable, itemId, data) {
        return this.putRequest(this.url(this.getOrderableEndpoint(orderable), 'items', itemId), data);
    };
    CartService.prototype.resetItemsInOrderable = function (orderable, itemIds) {
        return this.patchRequest(this.url(this.getOrderableEndpoint(orderable), 'items', 'reset'), {
            ids: itemIds,
        });
    };
    CartService.prototype.resetAllItemsInOrderable = function (orderable) {
        return this.patchRequest(this.url(this.getOrderableEndpoint(orderable), 'items', 'reset'), undefined);
    };
    CartService.prototype.deleteItemInOrderable = function (orderable, itemId) {
        return this.deleteRequest(this.url(this.getOrderableEndpoint(orderable), 'items', itemId));
    };
    CartService.prototype.updateNoteInOrderable = function (orderable, note) {
        return this.patchRequest(this.url(this.getOrderableEndpoint(orderable), 'note'), {
            note: note,
        });
    };
    CartService.prototype.deleteNoteInOrderable = function (orderable) {
        return this.deleteRequest(this.url(this.getOrderableEndpoint(orderable), 'note'));
    };
    CartService.prototype.recalculateOrderable = function (orderable) {
        return this.patchRequest(this.url(this.getOrderableEndpoint(orderable), 'recalculate'), undefined);
    };
    CartService.prototype.disableTaxesOrderable = function (orderable, disableTaxes) {
        return this.patchRequest(this.url(this.getOrderableEndpoint(orderable), 'taxes'), {
            disable_taxes: disableTaxes,
        });
    };
    CartService.prototype.getAvailableShippings = function (orderable) {
        return this.getRequest(this.url(this.getOrderableEndpoint(orderable), 'shipping'));
    };
    CartService.prototype.getPaymentMethods = function (orderable) {
        return this.getRequest(this.url(this.getOrderableEndpoint(orderable), 'payments'));
    };
    CartService.prototype.updateShippingInOrderable = function (orderable, data) {
        var url = this.url(this.getOrderableEndpoint(orderable), 'shipping');
        return this.patchRequest(url, data);
    };
    CartService.prototype.deleteShippingInOrderable = function (orderable) {
        return this.deleteRequest(this.url(this.getOrderableEndpoint(orderable), 'shipping'));
    };
    CartService.prototype.validateOrderable = function (orderable, data) {
        return this.postRequest(this.url(this.getOrderableEndpoint(orderable), 'validate'), data);
    };
    CartService.prototype.transitQuote = function (id, transitTo, data) {
        return this.patchRequest(this.url('quotes', id, 'transition', transitTo), data);
    };
    CartService.prototype.shippings = function (params) {
        return this.getCollectionRequest(this.url('shippings'), {
            params: params,
        });
    };
    CartService.prototype.getShipping = function (id) {
        return this.getRequest(this.url('shippings', id));
    };
    CartService.prototype.createShipping = function (shipping) {
        return this.postRequest(this.url('shippings'), shipping);
    };
    CartService.prototype.reindexShipping = function () {
        return this.postRequest(this.url('shippings', 'reindex'));
    };
    CartService.prototype.updateShipping = function (id, shipping) {
        return this.putRequest(this.url('shippings', id), shipping);
    };
    CartService.prototype.deleteShipping = function (id) {
        return this.deleteRequest(this.url('shippings', id));
    };
    CartService.prototype.convertToQuote = function (id) {
        return this.postRequest(this.url('carts', id, 'quotation'));
    };
    CartService.prototype.quotes = function (params) {
        return this.getCollectionRequest(this.url('quotes'), {
            params: params,
        });
    };
    CartService.prototype.getQuote = function (id) {
        return this.getRequest(this.url('quotes', id));
    };
    CartService.prototype.deleteQuote = function (id) {
        return this.deleteRequest(this.url('quotes', id));
    };
    CartService.prototype.massDeleteQuotes = function (data) {
        return this.deleteRequest(this.url('quotes'), { data: data });
    };
    CartService.prototype.boxes = function (params) {
        return this.getCollectionRequest(this.url('boxes'), {
            params: params,
        });
    };
    CartService.prototype.getBox = function (id) {
        return this.getRequest(this.url('boxes', id));
    };
    CartService.prototype.createBox = function (box) {
        return this.postRequest(this.url('boxes'), box);
    };
    CartService.prototype.updateBox = function (id, box) {
        return this.putRequest(this.url('boxes', id), box);
    };
    CartService.prototype.deleteBox = function (id) {
        return this.deleteRequest(this.url('boxes', id));
    };
    return CartService;
}(api_service_1.ApiService));
exports.default = CartService;
var CartLockState;
(function (CartLockState) {
    CartLockState["UNLOCKED"] = "unlocked";
    CartLockState["LOCKED"] = "locked";
    CartLockState["MANAGEMENT"] = "management";
    CartLockState["CHECKOUT"] = "checkout";
})(CartLockState = exports.CartLockState || (exports.CartLockState = {}));
var OrderableType;
(function (OrderableType) {
    OrderableType["CART"] = "cart";
    OrderableType["QUOTE"] = "quote";
})(OrderableType = exports.OrderableType || (exports.OrderableType = {}));
var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["ADJUSTING"] = "adjusting";
    QuoteStatus["APPROVED"] = "approved";
    QuoteStatus["AVAILABLE"] = "available";
    QuoteStatus["CLOSED"] = "closed";
    QuoteStatus["ERRORED"] = "errored";
    QuoteStatus["PENDING"] = "pending";
    QuoteStatus["PROCESSING"] = "processing";
    QuoteStatus["REJECTED"] = "rejected";
})(QuoteStatus = exports.QuoteStatus || (exports.QuoteStatus = {}));
var QuoteTransitionName;
(function (QuoteTransitionName) {
    QuoteTransitionName["ADJUST"] = "adjust";
    QuoteTransitionName["ADJUSTED"] = "adjusted";
    QuoteTransitionName["APPROVE"] = "approve";
    QuoteTransitionName["FULFILL"] = "fulfill";
    QuoteTransitionName["PLACE"] = "place";
    QuoteTransitionName["PROCESS"] = "process";
    QuoteTransitionName["RECOVER"] = "recover";
    QuoteTransitionName["REJECT"] = "reject";
    QuoteTransitionName["REVERT"] = "revert";
})(QuoteTransitionName = exports.QuoteTransitionName || (exports.QuoteTransitionName = {}));
var QuoteTransitionActivities;
(function (QuoteTransitionActivities) {
    QuoteTransitionActivities["CAN_APPROVE"] = "can-approve";
    QuoteTransitionActivities["CAN_FULFILL_WITH_USER_TYPE"] = "can-fulfill-with-user-type";
    QuoteTransitionActivities["CAN_MANAGE"] = "can-manage";
    QuoteTransitionActivities["CAN_MODIFY"] = "can-modify";
    QuoteTransitionActivities["CAN_PLACE"] = "can-place";
    QuoteTransitionActivities["CAN_RECOVER"] = "can-recover";
    QuoteTransitionActivities["CAN_REJECT"] = "can-reject";
    QuoteTransitionActivities["CAN_REQUEST_WITH_USER_TYPE"] = "can-request-with-user-type";
    QuoteTransitionActivities["CAN_REVERT"] = "can-revert";
})(QuoteTransitionActivities = exports.QuoteTransitionActivities || (exports.QuoteTransitionActivities = {}));
var ShippingType;
(function (ShippingType) {
    ShippingType["DELIVERY"] = "delivery";
    ShippingType["PICKUP"] = "pickup";
})(ShippingType = exports.ShippingType || (exports.ShippingType = {}));
var ShippingPriceType;
(function (ShippingPriceType) {
    ShippingPriceType["FIXED"] = "fixed";
    ShippingPriceType["PER_ITEM"] = "per_item";
})(ShippingPriceType = exports.ShippingPriceType || (exports.ShippingPriceType = {}));
//# sourceMappingURL=cart-service.js.map